export default __webpack_public_path__ + "static/media/6.b268e2f4.webp";